import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20
    }
}))

function HideablePanelHeader(props){
    const classes = useStyles();

    return (
        <div className={classes.container}>
            {props.children}
        </div>
    )
}

export default HideablePanelHeader;